module.exports = __webpack_public_path__ + "static/media/logo-image.797b2677.png";